import { useEffect, useState } from "react";
import styles from "./oldBrowserModal.module.scss";
import {
  Modal,
  Accordion,
  Accordions,
  useModal,
  Icon,
} from "@monta/design-system";
import LabelButton from "./lable";
import { descriptions, getBrowser } from "./browser-info";
const isOldVersion = (res: ReturnType<typeof getBrowser>) => {
  const { name, version } = res;
  if (!version) return false;
  switch (name) {
    case "Edge":
    case "Opera":
    case "Chrome":
      return version <= 94;
    case "Firefox":
      return version <= 92;
    case "Safari":
      return version <= 14;
    case "IE":
      return true;
    default:
      return false;
  }
};
const OldBrowserModal = () => {
  const controller = useModal();
  const [info, setInfo] = useState<ReturnType<typeof getBrowser> | undefined>();
  useEffect(() => {
    const info = getBrowser();
    setInfo(info);
    if (isOldVersion(info)) controller.open();
  }, []);

  return (
    <Modal
      className={styles["version-modal"]}
      maxHeight={"90vh"}
      bottomSheetOnMobile
      {...controller}
      width={"603px"}
      borderRadius={"20px"}
      style={{ borderRadius: "20px" }}
    >
      <div className={styles["version-modal__title"]}>
        <h3>به روزرسانی مرورگر!</h3>
        <Icon
          icon={"mi-Wrong-answer"}
          onClick={controller.close}
          size={1.2}
          color={"#8C8787"}
        />
      </div>
      <p className={styles["version-modal__content"]}>
        نسخه مرورگر {info?.name} شما نیاز به به روزرسانی دارد. درصورت عدم به
        روزرسانی ممکن است کاربری شما در سایت با اختلال مواجه شود.
      </p>
      <div className={styles["version-modal__accordions"]}>
        {info?.name && (
          <Accordions>
            <Accordion button={<LabelButton title={"راهنما"} />}>
              <p className={styles["version-modal__accordions__description"]}>
                <pre>{descriptions[info?.name]}</pre>
              </p>
            </Accordion>
          </Accordions>
        )}
      </div>
      <div className={styles["version-modal__button"]}>
        <button onClick={controller.close}>متوجه شدم</button>
      </div>
    </Modal>
  );
};

export default OldBrowserModal;
